
import { QuestionsAndAnswersTileModel } from '@/types/B2CcontentServerContract';
import { defineComponent, PropType } from '@vue/runtime-core';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue';
import MediaHandler from '@/shared/content/blocks/helpers/MediaHandler.vue';
import breakpointsState from '@/core/responsive/breakpoints/breakpoints-state.observable';
import { computed } from 'vue';

export default defineComponent({
    name: 'QuestionsAndAnswersTile',
    components: { Disclosure, DisclosureButton, DisclosurePanel, MediaHandler },
    props: {
        content: {
            type: Object as PropType<QuestionsAndAnswersTileModel>,
            required: true,
        },
    },
    setup(props) {
        const showMedia = computed(() => {
            const isMobile = breakpointsState.activeBreakpoint === 'xs';
            return props.content.media && (isMobile ? !props.content.hideImageOnMobile : true);
        });

        return {
            showMedia,
        };
    },
});
